import React from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Row, Col, FormControl, DropdownButton, MenuItem } from 'react-bootstrap';
import Datetime from 'react-datetime';
import forEach from 'lodash/forEach';
import find from 'lodash/find';
import map from 'lodash/map';
import moment from 'moment';
import Comments from '../../../../../components/Comments/Comments';
import SmallLoader from '../../../../../components/SmallLoader/index';
import { validateFields } from '../../../../../shared/utils/handleBlowoutValidations';
import {
    createTapRecoveryAction,
    getIsPending,
    clearErrorMessage,
    getError,
} from '../../../recoveryActionsDuck';
import { post } from '../../../../../shared/http/request';
import { handleApiError } from '../../../../../shared/http/error';
import { bindActionCreators } from 'redux';
import { formatRun } from '../../../../../shared/utils/run';

class TapModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tapDate: '',
            dueDate: '',
            comment: '',
            tapNumber: '',
            validations: {},
            commonRuns: [],
            fetchingCommonRuns: false,
            selectedRun: 'Route code - run date - run sequence',
            selectedRunId: '',
        };
    }

    componentDidMount() {
        this.setState(() => ({ fetchingCommonRuns: true }));
        post(`/api/abnormality/manifests/common-runs`, {
            manifestIds: this.props.selectedManifestIds,
        }).then(
            response =>
                this.setState({
                    commonRuns: response.runs,
                    fetchingCommonRuns: false,
                }),
            error => {
                this.setState(() => ({ fetchingCommonRuns: false }));
                handleApiError(error, this.props.dispatch);
            }
        );
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isPending && !nextProps.isRejected) {
            this.props.onClose('openTapModal');
        }
    }

    componentWillUnmount() {
        this.props.clearErrorMessage();
    }

    handleDateChange = momentDate => {
        let tempVal = this.state.validations;
        delete tempVal.tapDate;
        if (!moment(momentDate).isValid()) {
            tempVal.tapDate = 'Please insert a valid date with format: DD-MM-YYYY HH:mm';
        }
        this.setState({ validations: tempVal, tapDate: momentDate });
    };

    handleDueDateChange = momentDate => {
        let tempVal = this.state.validations;
        delete tempVal.dueDate;
        if (!moment(momentDate).isValid()) {
            tempVal.dueDate = 'Please insert a valid date with format: DD-MM-YYYY HH:mm';
        }
        this.setState({ validations: tempVal, dueDate: momentDate });
    };

    handleTapNumberChange = e => {
        this.setState({ tapNumber: e.currentTarget.value });
        if (this.state.validations.tapNumber) {
            let tempVal = this.state.validations;
            delete tempVal.tapNumber;
            this.setState({ validations: tempVal });
        }
    };

    handleCommentChange = e => {
        this.setState({ comment: e.currentTarget.value });
    };

    handleRunChange = runId => {
        if (this.props.errorMessage) {
            this.props.clearErrorMessage();
        }
        if (this.state.validations.runs) {
            let tempVal = this.state.validations;
            delete tempVal.runs;
            this.setState({ validations: tempVal });
        }
        const run = find(this.state.commonRuns, run => run.runId === runId);
        if (run) {
            const displayedRun = formatRun(run);
            this.setState({
                selectedRun: displayedRun,
                selectedRunId: run.runId,
            });
        }
    };

    handleConfirm = () => {
        const { comment, tapDate, tapNumber, selectedRun, selectedRunId, dueDate } = this.state;
        const { selectedAbnManifestIds, abnormalityAnalysis, manifestGroups } = this.props;

        const validations = validateFields({
            selectedRun,
            tapDate,
            selectedAbnManifestIds,
            dueDate,
        });
        this.setState({ validations: validations });
        if (!validations.tapDate) {
            let tempManList = [];
            forEach(selectedAbnManifestIds, selManId =>
                forEach(manifestGroups, group =>
                    forEach(group.manifests, manifest => {
                        if (selManId === manifest.abnormalityManifestId) {
                            //selectedAbnManifestIds consist of abnormalityManifestIds
                            tempManList.push({
                                manifestId: manifest.manifest.manifestId,
                                abnormalityManifestId: manifest.abnormalityManifestId,
                            });
                        }
                    })
                )
            );

            const formData = {
                abnormalityId: abnormalityAnalysis.abnormalityId,
                abnormalityManifests: tempManList,
                comment: comment,
                tapDate: tapDate.toISOString(),
                tapNumber: tapNumber,
                dueDate: dueDate.toISOString(),
                runId: selectedRunId,
            };

            this.props.createTapRecoveryAction(formData);
        }
    };

    render() {
        const { showModal, onClose, onHide, backdrop, isPending } = this.props;
        const {
            comment,
            tapDate,
            tapNumber,
            validations,
            dueDate,
            commonRuns,
            fetchingCommonRuns,
            selectedRun,
        } = this.state;

        return (
            <Modal show={showModal} backdrop={backdrop} onHide={onHide}>
                <Modal.Header>
                    <Modal.Title>Tap</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {isPending ? (
                        <div className="text-center">
                            <SmallLoader />
                        </div>
                    ) : (
                        <div>
                            <Row style={{ marginBottom: 20 }}>
                                <Col sm={5} style={{ marginTop: 5 }}>
                                    Run you want to tap to
                                </Col>
                                <Col sm={7}>
                                    {fetchingCommonRuns && <SmallLoader />}
                                    {!fetchingCommonRuns && (
                                        <DropdownButton
                                            id="commonRuns"
                                            style={
                                                validations.runs && {
                                                    borderColor: '#CF142B',
                                                }
                                            }
                                            title={selectedRun}
                                            onSelect={this.handleRunChange}
                                        >
                                            {map(commonRuns, run => {
                                                return (
                                                    <MenuItem
                                                        key={run.runId}
                                                        eventKey={run.runId}
                                                        active={selectedRun === formatRun(run)}
                                                    >
                                                        {formatRun(run)}
                                                    </MenuItem>
                                                );
                                            })}
                                        </DropdownButton>
                                    )}
                                    {validations &&
                                        validations.runs && (
                                            <p
                                                style={{
                                                    color: '#CF142B',
                                                    marginTop: 5,
                                                }}
                                            >
                                                {validations.runs}
                                            </p>
                                        )}
                                </Col>
                            </Row>
                            <Row style={{ marginBottom: 20 }}>
                                <Col sm={5}>
                                    <p>Due date *</p>
                                </Col>
                                <Col sm={6}>
                                    <Datetime
                                        className={validations.dueDate && 'datetime-error'}
                                        value={dueDate}
                                        onChange={this.handleDueDateChange}
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat="HH:mm"
                                        inputProps={{ maxLength: 255 }}
                                    />
                                    {validations &&
                                        validations.dueDate && (
                                            <p
                                                style={{
                                                    color: '#CF142B',
                                                    marginTop: 5,
                                                }}
                                            >
                                                {validations.dueDate}
                                            </p>
                                        )}
                                </Col>
                            </Row>
                            <Row style={{ marginBottom: 20 }}>
                                <Col sm={5}>
                                    <p>Tap date *</p>
                                </Col>
                                <Col sm={6}>
                                    <Datetime
                                        className={validations.tapDate && 'datetime-error'}
                                        value={tapDate}
                                        onChange={this.handleDateChange}
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat="HH:mm"
                                        inputProps={{ maxLength: 255 }}
                                    />
                                    {validations &&
                                        validations.tapDate && (
                                            <p
                                                style={{
                                                    color: '#CF142B',
                                                    marginTop: 5,
                                                }}
                                            >
                                                {validations.tapDate}
                                            </p>
                                        )}
                                </Col>
                            </Row>
                            <Row style={{ marginBottom: 20 }}>
                                <Col sm={5}>
                                    <p>Tap number</p>
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        style={
                                            validations.tapNumber && {
                                                borderColor: '#CF142B',
                                            }
                                        }
                                        type="text"
                                        maxLength="1000"
                                        value={tapNumber}
                                        onChange={this.handleTapNumberChange}
                                    />
                                    {validations &&
                                        validations.tapNumber && (
                                            <p
                                                style={{
                                                    color: '#CF142B',
                                                    marginTop: 5,
                                                }}
                                            >
                                                {validations.tapNumber}
                                            </p>
                                        )}
                                </Col>
                            </Row>
                            <Row>
                                <div style={{ margin: 15 }}>
                                    <Comments
                                        comment={comment}
                                        onCommentChange={this.handleCommentChange}
                                    />
                                </div>
                            </Row>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="pull-right"
                        style={{ marginRight: 20 }}
                        bsStyle="success"
                        onClick={isPending ? null : this.handleConfirm}
                        disabled={isPending || !!validations.dueDate || !!validations.tapDate}
                    >
                        Create
                    </Button>
                    <Button
                        className="pull-right"
                        style={{ marginRight: 20 }}
                        bsStyle="default"
                        onClick={isPending ? null : onClose}
                        disabled={isPending}
                    >
                        Dismiss
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default connect(
    state => ({
        isPending: getIsPending(state),
        isRejected: getError(state),
    }),
    dispatch => bindActionCreators({ createTapRecoveryAction, clearErrorMessage }, dispatch)
)(TapModal);
